import * as React from 'react';
import { format } from 'date-fns';
import { Prompt } from 'react-router';
import { reduxForm, formValueSelector } from 'redux-form';
import { Card } from 'material-ui';
import { compose, withProps, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import * as uuid from 'uuid/v4';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { TripsHistoriesForm } from '@modules/trips/TripsHistoriesForm';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';
import { Tabs } from '@components/tabs';

import { TripsFormBasic } from '@modules/trips/TripsFormBasic';
import { getTrip, putTrip } from '@modules/trips/_tripsActions';

import * as T from '@modules/trips/_tripsTypes';
import { withNotifications } from '@components/hoc/withNotifications';
import { Loader } from '@components/loader';

export const enhance = compose<T.TripsFormProps, T.Outter>(
  entityDetailEnhancer<T.TripsEnhancerProps<T.Trip>, T.Trip>({
    getEntity: getTrip,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Služební jízdy', to: '/trips' },
    { label: entity && entity.id ? 'Upravit záznam' : 'Nový záznam' }
  ]),
  withNotifications({ putTrip }),
  withState<{}, boolean, string, string>('loader', 'handleLoader', false),
  withProps<{}, T.TripsProps>(({ entity }) => {
    const end = entity && entity.endMileage ? entity.endMileage : 0;
    const start = entity && entity.startMileage ? entity.startMileage : 0;
    return {
      initialValues: {
        totalMileage: end - start,
        ...entity
      },
      maxYear: format(new Date(), 'YYYY')
    };
  }),
  connect(state => ({
    startMileage: formValueSelector('Trips')(state, 'startMileage'),
    endMileage: formValueSelector('Trips')(state, 'endMileage')
  })),
  withHandlers({
    onSubmit: ({ putTripNotify, closeItem, handleLoader }) => async formData => {
      if (handleLoader) {
        handleLoader(true);
      }
      const body = { id: formData.id ? formData.id : uuid(), ...formData };
      const event = await putTripNotify(body);
      if (handleLoader) {
        handleLoader(false);
      }
      if (event) {
        closeItem();
      }
    }
  }),
  reduxForm({
    form: 'Trips'
  })
);

export const View: React.SFC<T.Outter & T.TripsFormProps> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    {props.loader && <Loader />}
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        {props.entity ? (
          <Tabs
            items={[
              {
                label: 'Editace',
                style: { minWidth: 150 },
                content: (
                  <TripsFormBasic
                    dispatch={props.dispatch}
                    startMileage={props.startMileage}
                    endMileage={props.endMileage}
                  />
                )
              },
              { label: 'Historie', style: { minWidth: 150 }, content: <TripsHistoriesForm /> }
            ]}
          />
        ) : (
          <TripsFormBasic dispatch={props.dispatch} startMileage={props.startMileage} endMileage={props.endMileage} />
        )}
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={props.closeItem} />
      </Card>
    </form>
  </div>
);

export const TripsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/trips/TripsForm.tsx